import { Box, Typography } from "@mui/material";
import { ResolvedColors } from "../colorResolver";

interface IClashfinderPreviewProps {
  colors: ResolvedColors;
  priorityColors: string[];
}

const STAGES = ["Main", "Second", "Tent"];

export const ClashfinderPreview = ({ colors, priorityColors }: IClashfinderPreviewProps) => {
  return (
    <Box sx={{ width: "100%", height: "100%", backgroundColor: colors.backgroundColor }}>
      <Box sx={{ backgroundColor: colors.clashfinderHeader, px: 2, py: 1.5 }}>
        <Typography variant="body2" sx={{ color: colors.primaryColorText, fontWeight: 700 }}>
          Clashfinder — Friday
        </Typography>
      </Box>

      <Box sx={{ display: "flex", backgroundColor: colors.stageHeader }}>
        {STAGES.map((stage) => (
          <Box key={stage} sx={{ flex: 1, textAlign: "center", py: 1 }}>
            <Typography variant="caption" sx={{ color: colors.primaryColorText, fontWeight: 700 }}>
              {stage}
            </Typography>
          </Box>
        ))}
      </Box>

      {[0, 1, 2].map((row) => (
        <Box key={row} sx={{ display: "flex", gap: 0.75, px: 1, py: 0.75 }}>
          {STAGES.map((stage, col) => (
            <Box
              key={stage}
              sx={{
                flex: 1,
                height: 44,
                borderRadius: 0.5,
                backgroundColor: priorityColors[(row + col) % priorityColors.length],
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                px: 0.75,
                overflow: "hidden",
              }}
            >
              <Typography
                variant="caption"
                noWrap
                sx={{ color: colors.alternativeTextColor, fontSize: 10, fontWeight: 700, lineHeight: 1.2 }}
              >
                Band {row + col + 1}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: colors.alternativeTextColor, fontSize: 9, opacity: 0.85 }}
              >
                {18 + row}:00
              </Typography>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
